<div class="viewport-1" [style.background-image]="'url(' + getTaskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div
    class="task-screen-element find-the-syllables-container"
    [style.background-image]="' ' + getTaskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{ getTestType() }}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()" disabled="disableAVButtons"></button>
    </div>
    <div class="find-the-syllables-main-container">
      <div class="find-the-syllables-image-container" [hidden]="!currentWordImage">
        @if (currentWordImage) {
          <img
            [src]="currentWordImage"
            [alt]="'Image for word'"
            class="find-the-syllables-word-image"
            (error)="currentWordImage = null">
        }
      </div>
      <div [class]="{ 'find-number-syllables-target-area': !isUnit, 'find-number-syllables-target-area-instructional': isUnit, 'find-number-syllables-target-area-non-auditory-spacing': (!auditoryTask && !unmaskedTask) }">
        <div class="audio-controls-container find-the-syllables-speaker-position">
          <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons" [hidden]="!isSpeakerVisible()"></button>
          <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed()" [disabled]="disableAVButtons" [hidden]="!isSpeakerVisible()"></button>
        </div>
        <div [class]="(isUnit) ? 'find-number-syllables-target-text-instructional font-50' : 'find-number-syllables-target-text font-42'">
          <div [class.masked-syllable-target-word]="isUnit" [hidden]="!shouldMask">######</div>
          <!-- If pre/post test: show the target word as normal... no need to worry about syllable parts -->
          @if (!isUnit) {
            <div [hidden]="shouldMask">{{ targetWord }}</div>
          }
          <!-- This initial state is necessary to keep the syllable parts formatted as closely together as possible (the buttons space out the syllable
          container and can lead to very obvious syllable breaks before the student even attempts a response) -->
          @if (isUnit && !firstResponseIncorrect) {
            <div>
              @for (syllablePart of targetSyllables; track syllablePart; let idx = $index) {
                <div class="syllable-container-initial">
                  <div
                    class="syllable-text syllable-{{ syllablePart.syllableNum }}"
                    [class.colored]="showSupportAudioAndHighlights"
                    [class.underline]="syllablePart.underline"
                    [hidden]="shouldMask"
                  >
                    {{ syllablePart.syllable }}
                  </div>
                </div>
              }
            </div>
          }

          <!-- Once the student has missed a response, add in the support audio btns. Depending on the length of the syllable this can lead to some increased
          spacing between letters, but it at least fits the purpose of making the syllables more obvious to the student -->
          @if (isUnit && firstResponseIncorrect) {
            <div class="syllable-container">
              @for (syllablePart of targetSyllables; track syllablePart; let idx = $index) {
                <div class="syllable-container">
                  <button class="syllable-audio-btn-hidden" [disabled]="disableAVButtons" [hidden]="showSupportAudioAndHighlights"></button>
                  <button class="syllable-audio-btn" [disabled]="disableAVButtons" [hidden]="!showSupportAudioAndHighlights" (click)="requestSyllableHelp(idx)"></button>
                  <div
                    class="syllable-text syllable-{{ syllablePart.syllableNum }}"
                    [class.colored]="showSupportAudioAndHighlights"
                    [class.underline]="syllablePart.underline"
                    [hidden]="shouldMask">
                    {{ syllablePart.syllable }}
                  </div>
                </div>
              }
            </div>
          }
          <button
            style="position: relative; bottom: 10px; width: 5%;"
            [hidden]="unmaskedTask"
            [disabled]="disableAgainButton"
            [class]="{ 'again-button-grayed' : disableAgainButton, 'again-button' : !disableAgainButton, 'toggle-again-on' : toggleAgainButton, 'again-button-hidden': hideAgainButton }"
          (click)="displayTrialAgain()"></button>
        </div>
      </div>
    </div>

    <div class="full-response-row">
      <button
        [hidden]="auditoryTask || unmaskedTask"
        [disabled]="disableNextButton"
        [class]="{ 'next-button-grayed' : disableNextButton, 'next-button' : !disableNextButton, 'toggle-next-on' : toggleNextButton, 'next-button-hidden': hideNextButton }"
      (click)="displayTrial()"></button>
    </div>

    <div class="syllable-response-row">
      @for (response of responseOptions; track response.syllables; let idx = $index) {
        <div class="button-div">
          <button
            [disabled]="disableResponseButtons"
            [class]="{ 'hover': response.highlight, 'syllable-response-correct-grayed': (disableResponseButtons && !isUnit), 'syllable-response-correct': (!disableResponseButtons || isUnit) }"
            [style]="{'border-color':' ' + getHighlightColor() + ' ', 'background-color': getButtonColor() + ' ', 'color': getTaskBarColor() + ' '}"
            (click)="submitResponse(response) ; removeHoverClass($event)"
            (touchstart)="addHoverClass($event)"
            (touchend)="removeHoverClass($event)"
            (mousemove)="addHoverClass($event)"
            (mouseenter)="addHoverClass($event)"
            (mouseleave)="removeHoverClass($event)">
            {{ response.syllables }}
          </button>
        </div>
      }
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
